<template>
	<div class="container__menuuser__allnotification">
		<div
			ref="ref_icon"
			class="container__menuuser__allnotification__icons"
			@click="isCardActived = !isCardActived"
		>
			<slot name="icon" />
		</div>
		<div
			v-show="isCardActived"
			ref="ref_card"
			v-closable="{
				exclude: ['ref_icon', 'ref_card'],
				handler: 'onClose',
			}"
			class="container__menuuser__card"
		>
			<slot name="card" />
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isCardActived: false,
		}
	},
	methods: {
		onClose() {
			this.isCardActived = false
		},
	},
}
</script>

<style>
.container__menuuser__allnotification__icons {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	height: var(--menu-height);
}

.container__menuuser__card {
	position: fixed;
	top: var(--menu-height);
	left: 0;
	width: 100vw;
}

@media screen and (min-width: 576px) {
	.container__menuuser__allnotification {
		position: relative;
	}
	.container__menuuser__card {
		max-width: 20rem;
		position: absolute;
		top: calc(var(--menu-height) + 0.3rem);
		transform: translateX(-17.6rem);
	}
}
</style>
